import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

async function NivelCumplimientoInformeConservacionDetalleService(values) {
    try {
        return await instance.Backend.post("/Indicador/NivelCumplimientoInformeConservacionDetalle"
            , values
            , customConfig);
    } catch (error) {
        console.log(error);
    }
}

export { NivelCumplimientoInformeConservacionDetalleService };
